import React from "react";

import styles from "./StoreSelector.module.scss";
import { PublicStoreInterface } from "../../../common/types/interfaces";

interface Props {
  stores: PublicStoreInterface[];
  pickUpStore?: number;
  onChange: (id: number) => void;
}

export const StoreSelector: React.FC<Props> = ({
  stores,
  pickUpStore,
  onChange,
}) => {
  return (
    <div className={styles.Container}>
      <h3 className={styles.Title}>Точка самовывоза</h3>

      <div className={styles.Options}>
        {stores.map((store) => {
          const isActive = pickUpStore === store.id;
          return (
            <button
              key={store.id}
              type="button"
              className={`${styles.Option} ${isActive ? styles.Active : ""}`}
              onClick={() => onChange(Number(store.id))}
            >
              <span className={styles.Name}>{store.name}</span>
              <span className={styles.Address}>
                {[store.city?.value, store.address?.value]
                  .filter(Boolean)
                  .join(", ")}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};